/**
 * Created with IntelliJ IDEA.
 * User: raml
 * Date: 7/9/13
 * Time: 10:39 AM
 * This model is an interface for the topLevelMenuItem controller.
 */
define(function (require) {
    "use strict";

    var Backbone = require("backbone");

    var TYPES = {
        TEXT: "text",
        AVAILABILITY: "availability",
        ICON: "icon"
    };

    // constants

    var TrayMenuItemModel = Backbone.Model.extend({
        TYPES: TYPES,
        defaults: {
            tooltip: "",
            callback: function(){
                return false;
            },
            context: this,
            iconClass: "",
            type: TYPES.ICON,
            text: "",
            index: "",
            trayItemTextClass: "",
            withBubble: false,
            bubbleTargetControl: "",
            bubbleText: "",
            bubblePosition: "",
            bubbleIcon: "",
            bubbleShowCloseButton: false,
            bubbleTitle: "",
            bubblePermutation: "",
            buttonCaption: "",
            bubbleButtonCallback: undefined,
            bubbleButtonPermutation: null,
            bubbleCloseOutsideClick: true
        },
        name: "TrayMenuItemModel",
        setTooltip: function(tooltip) {
            this.set("tooltip", tooltip);
        }
    });

    TrayMenuItemModel.TYPES = TYPES;

    return TrayMenuItemModel;
});
